import React from 'react';

const Check = ({ onSelected, selected = false, text = '' }) => {
  return (
    <div
      style={{
        textAlign: 'left',
        display: 'flex',
        cursor: 'pointer',
        padding: text.toLowerCase() === 'other:' ? '0 5px' : '5px',
      }}
      onClick={onSelected}
    >
      <div
        style={{
          width: '10px',
          height: '10px',
          border: '1px solid #d3d3d3',
          borderRadius: '2px',
          overflow: 'hidden',
          marginRight: '8px',
          position: 'relative',
          top: text.toLowerCase() === 'other:' ? '7px' : '3px',
        }}
      >
        {selected && (
          <div
            style={{
              backgroundColor: '#399ff7',
              width: '8px',
              height: '8px',
              borderRadius: '2px',
              position: 'relative',
            }}
          ></div>
        )}
      </div>
      <div style={{ flex: 1, display: 'flex' }}>
        <div
          className="fs-15"
          style={{ marginTop: text.toLowerCase() === 'other:' ? '3px' : 0 }}
        >
          {text}
        </div>
        {text.toLowerCase() === 'other:' && (
          <div style={{ flex: 1, margin: '0 10px' }}>
            <input type="text" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Check;
